import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

import { environment } from '../app/environments/environment';

/*
  Generated class for the TokenVerify provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class TokenVerify {
  private url = environment.api_url + 'api/token-verify/';

  constructor(public http: Http) {
    console.log('Hello TokenVerify Provider');
  }

  verify(credentials): Observable<boolean> {
    return this.performTokenVerify(credentials.token);
  }

  private performTokenVerify(token: string): Observable<boolean> {
    let credentials = { token: token };

    return this.http.post(this.url, credentials)
      .map((res: Response) => {
        if (res.ok) { this.handleVerifySuccess(res); }
        else { this.handleVerifyFail(res); }
        return res.ok;
      });
  }

  private handleVerifySuccess(response: Response) {
    console.count('Token verify succeeded');
  }

  private handleVerifyFail(response: Response) {
    console.count('Token verify failed');
  }
}



// WEBPACK FOOTER //
// ./src/providers/token-verify.ts